var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3885 7.99995C1.3885 11.1977 3.98998 13.7991 7.18768 13.7991C7.57108 13.7991 7.8819 14.11 7.8819 14.4934C7.8819 14.8768 7.57108 15.1876 7.18768 15.1876C3.22434 15.1876 1.13032e-05 11.9633 1.11299e-05 7.99998C1.09567e-05 4.03664 3.22437 0.81231 7.18768 0.81231C10.7258 0.812309 13.6732 3.38262 14.2651 6.75376C14.2916 6.90483 14.4321 7.02804 14.5854 7.02804L15.847 7.02804C16.0004 7.02804 16.0461 7.12429 15.9491 7.24306L13.8569 9.80287C13.7598 9.92164 13.6025 9.92164 13.5054 9.80287L11.4132 7.24306C11.3161 7.12426 11.3619 7.02804 11.5152 7.02804L12.6261 7.02804C12.7795 7.02804 12.8837 6.90519 12.8508 6.75542C12.2796 4.15404 9.9581 2.20071 7.18771 2.20071C3.98997 2.20077 1.3885 4.80224 1.3885 7.99995Z",
    fill: "#00427D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIReset);
export default __webpack_public_path__ + "static/media/i_reset.683eb1e686e1fa840ff3cbaea32eed99.svg";
export { ForwardRef as ReactComponent };